import { Project, Experience, Skill, Certification, Education } from './types';

export const LINKS = {
  email: 'royakash434@gmail.com',
  phone: '+91 8283075790',
  phoneHref: 'tel:+918283075790',
  linkedin: 'https://linkedin.com/in/akxshrxy',
  github: 'https://github.com/akxshrxy',
  instagram: 'https://instagram.com/akashroyyyyyyyy',
  resume: 'https://drive.google.com/file/d/1bf9e-vA87N0dSMMaVhqCmzCGD7ppUsVF/view?usp=sharing',
};

export const RESUME_SUMMARY =
  'MBA graduate in Finance driving core banking, CRM and LOS transformation initiatives at ESAF Small Finance Bank. Skilled in financial analysis, data visualization and automation using Excel, SPSS and web technologies — bringing finance, analytics and product thinking together to improve decision making and operational efficiency.';

export const PERSONAL_STATEMENT =
  'I believe transformation is not a slide deck — it is shipped tools, cleaner data and decisions made faster. I work from inside the business: I find the friction, build the fix and stay until it is adopted.';

// Big statement on the black quote section
export const QUOTE =
  'Talent is loud for a day; discipline is quiet for a decade. I stopped waiting for lightning and learned to build my own weather — one honest hour, one finished thing, every single day, until the quiet work becomes impossible to ignore.';

export const PROJECTS: Project[] = [
  {
    id: 'cb-rejection',
    title: 'CB Rejection Dashboard',
    subtitle: 'Data Visualization & Analytics',
    description:
      'Analytics dashboard for credit bureau rejection patterns — turning raw rejection data into decisions on the loan approval process.',
    icon: 'BarChart3',
    tags: ['HTML / CSS / JS', 'Data Analysis', 'Power BI'],
    stats: [
      { value: '~30%', label: 'Reporting effort cut' },
      { value: 'Daily', label: 'Refresh cadence' },
      { value: '100%', label: 'Digitized' },
    ],
    details: {
      overview:
        'As part of PMO initiatives driving CBS, CRM and LOS transformation, I built a CB Rejection Dashboard to analyze rejection patterns and improve the loan approval process — replacing manual spreadsheet reporting with a live analytical view.',
      features: [
        'Automated data ingestion from multiple sources',
        'Interactive visualizations of rejection reasons',
        'Trend analysis over time',
        'Exportable reports for senior management',
      ],
      technologies: ['HTML', 'CSS', 'JavaScript', 'Excel', 'Power BI'],
      achievements: [
        { value: '~30%', label: 'Less manual reporting' },
        { value: 'Real-time', label: 'Data visibility' },
        { value: '100%', label: 'Process automation' },
      ],
      challenges:
        'Integrating data from legacy systems was the hard part. I created a standardized data entry protocol and automated the cleaning process with JavaScript and Excel macros.',
    },
  },
  {
    id: 'branch-locator',
    title: 'Branch Locator',
    subtitle: 'Geographic Analytics',
    description:
      'Interactive map of the branch network with performance overlays — built to support strategic planning and resource allocation.',
    icon: 'Map',
    tags: ['Mapping APIs', 'Data Visualization', 'HTML / JS'],
    stats: [
      { value: 'Visual', label: 'Insights' },
      { value: 'Strategic', label: 'Planning' },
      { value: 'Live', label: 'Tracking' },
    ],
    details: {
      overview:
        'Developed a Branch Locator using web technologies to visualize branch locations and performance metrics, giving leadership a geographic lens for planning and resource allocation.',
      features: [
        'Geographic visualization of the branch network',
        'Color-coded performance metrics',
        'Interactive tooltips with branch details',
        'Region-level filtering',
      ],
      technologies: ['HTML', 'CSS', 'JavaScript', 'Mapping APIs'],
      achievements: [
        { value: 'Improved', label: 'Strategic planning' },
        { value: 'Visual', label: 'Performance tracking' },
        { value: 'Enhanced', label: 'Data accessibility' },
      ],
      challenges:
        'Keeping the map responsive on lower-end branch hardware. I optimized rendering logic and chose lightweight libraries over heavy mapping stacks.',
    },
  },
  {
    id: 'gold-loan-calculator',
    title: 'Gold Loan Eligibility Calculator',
    subtitle: 'Process Automation',
    description:
      'Web tool that automates gold loan eligibility assessment — removing manual calculation errors and speeding up service at the counter.',
    icon: 'Calculator',
    tags: ['Automation', 'JavaScript', 'Financial Tools'],
    stats: [
      { value: 'Instant', label: 'Calculation' },
      { value: '0', label: 'Manual errors' },
      { value: 'High', label: 'Adoption' },
    ],
    details: {
      overview:
        'Created a Gold Loan Eligibility Calculator to automate the assessment process for customers, reducing manual calculation errors and speeding up service delivery in branches.',
      features: [
        'Real-time eligibility calculation',
        'Integration with current gold rates',
        'Branch-staff-friendly interface',
        'Printable summary generation',
      ],
      technologies: ['HTML', 'CSS', 'JavaScript'],
      achievements: [
        { value: '100%', label: 'Accuracy' },
        { value: 'Reduced', label: 'Processing time' },
        { value: 'High', label: 'Adoption rate' },
      ],
      challenges:
        'Handling variable gold rates and layered eligibility criteria. I built a flexible configuration module so rates update without touching the logic.',
    },
  },
];

export const EXPERIENCE: Experience[] = [
  {
    id: 'esaf',
    role: 'Business Transformation Manager, PMO & Transformation',
    company: 'ESAF Small Finance Bank',
    period: 'July 2024 — Present',
    location: 'Kerala, India',
    description:
      'Driving CBS, CRM and LOS transformation from inside the PMO — and building the analytics tools that keep the program honest.',
    highlights: [
      'Led PMO workstreams for CBS, CRM and LOS transformation across 3 business units, driving on-time delivery with 5+ cross-functional teams spanning technology, operations and compliance.',
      'Built and deployed 3 internal analytics tools — CB Rejection Dashboard, Branch Locator and Gold Loan Eligibility Calculator — cutting manual reporting effort by ~30% and improving real-time data visibility across branches.',
      'Managed and monitored a ₹600+ crore loan portfolio across product segments, conducting weekly risk analysis and delinquency tracking that supported senior leadership decisions on provisioning and collections strategy.',
      'Automated 4+ internal MIS reporting workflows on Oracle Flexcube data pipelines — cutting report generation from ~2 hours to under 20 minutes and eliminating manual data entry errors.',
      'Executed SIT and UAT for 3+ core banking modules, logging and tracking 150+ defects to resolution with zero critical bugs at go-live.',
      'Leveraged GenAI tools — prompt engineering and AI-assisted prototyping — to cut research-to-insight turnaround by ~40%.',
    ],
    skills: [
      'PMO & Transformation',
      'CBS / CRM / LOS',
      'Process Automation',
      'Risk Analysis',
      'SIT & UAT',
      'GenAI Tooling',
    ],
  },
  {
    id: 'aniidco',
    role: 'Finance Intern — Cash Handling & Taxation',
    company: 'ANIIDCO',
    period: 'March 2024 — May 2024',
    location: 'Andaman & Nicobar Islands',
    description:
      'Financial operations, reconciliation and statutory compliance for government-funded initiatives.',
    highlights: [
      'Processed 250+ financial transactions per week in Tally ERP with 100% compliance to regulatory timelines, supporting timely disbursement and documentation of government-funded initiatives.',
      'Reconciled daily cash balances and verified supporting documentation, minimizing discrepancies during internal audits.',
      'Assessed tax liabilities and prepared statutory returns per government guidelines, improving accuracy and timeliness of submissions.',
    ],
    skills: ['Tally ERP', 'Reconciliation', 'Taxation', 'Audit Compliance', 'Financial Reporting'],
  },
  {
    id: 'hdfc',
    role: 'Management Intern — Finance & Marketing',
    company: 'HDFC Life',
    period: 'June 2023 — July 2023',
    location: 'Vellore, India',
    description:
      'Insurance product promotion, customer segmentation and localized campaign execution.',
    highlights: [
      'Supported promotion and customer education for life insurance products — ULIPs, term plans, endowment and retirement solutions.',
      'Analyzed customer segments to tailor product recommendations and improve lead conversion.',
      'Collaborated with branch teams on localized marketing campaigns for individual and group insurance plans.',
    ],
    skills: ['Customer Analysis', 'Insurance Products', 'Lead Conversion', 'Campaign Execution'],
  },
];

export const EDUCATION: Education[] = [
  {
    degree: 'Master of Business Administration',
    major: 'Major in Finance · Minor in Marketing',
    institution: 'Vellore Institute of Technology',
    year: '2024',
    location: 'Vellore, Tamil Nadu, India',
  },
  {
    degree: 'Bachelor of Commerce (Honors)',
    major: 'Major in Accounts and Taxation',
    institution: 'Chandigarh University',
    year: '2020',
    location: 'Chandigarh, India',
  },
];

// Skill groups straight from the resume
export const SKILL_GROUPS: { title: string; items: string[] }[] = [
  {
    title: 'Analytics & Tools',
    items: [
      'Microsoft Excel (Pivot Tables, VBA)',
      'SQL',
      'Power BI',
      'IBM SPSS',
      'Predictive Analytics',
      'Financial Modeling',
      'Data Visualization',
      'Tally ERP',
      'Oracle Flexcube',
    ],
  },
  {
    title: 'Development & Automation',
    items: [
      'HTML / CSS / JavaScript',
      'Basic Python',
      'Vibe Coding',
      'GenAI Prompting & Hypothesis Generation',
      'Process Automation',
    ],
  },
  {
    title: 'Banking Domain',
    items: [
      'CBS / CRM / LOS Transformation',
      'Loan Portfolio Management',
      'SIT & UAT Testing',
      'MIS Reporting',
      'Regulatory Compliance',
    ],
  },
  {
    title: 'Consulting & Business',
    items: [
      'Structured Problem-Solving',
      'Stakeholder Management',
      'Business Research & Insights',
      'Cross-functional Collaboration',
      'Microsoft PowerPoint',
    ],
  },
];

export const LANGUAGES = ['English — Fluent', 'Hindi — Native', 'Bengali — Native'];

// Kept for the About page soft-skill meters
export const SKILLS_SOFT: Skill[] = [
  { name: 'Communication', description: 'Effective stakeholder interaction', level: 'Expert' },
  { name: 'Leadership', description: 'Team guidance and motivation', level: 'Advanced' },
  { name: 'Problem-Solving', description: 'Analytical resolution', level: 'Expert' },
  { name: 'Teamwork', description: 'Collaborative synergy', level: 'Expert' },
  { name: 'Persuasion', description: 'Influencing decisions', level: 'Advanced' },
  { name: 'Critical Thinking', description: 'Strategic analysis', level: 'Expert' },
  { name: 'Emotional Intelligence', description: 'Interpersonal awareness', level: 'Advanced' },
];

export const SKILLS_TECH: Skill[] = [
  { name: 'Data Visualization', description: 'Visualizing complex datasets', level: 'Expert' },
  { name: 'IBM SPSS', description: 'Statistical analysis', level: 'Advanced' },
  { name: 'Predictive Analytics', description: 'Forecasting and trends', level: 'Advanced' },
  { name: 'Financial Modeling', description: 'Valuation and risk analysis', level: 'Advanced' },
  { name: 'Tally ERP', description: 'Accounting software', level: 'Expert' },
  { name: 'Microsoft Excel', description: 'Pivot Tables, VBA, automation', level: 'Expert' },
  { name: 'GenAI Prompting', description: 'AI-assisted analysis & prototyping', level: 'Advanced' },
  { name: 'Oracle Flexcube', description: 'Core banking solution', level: 'Intermediate' },
  { name: 'SIT & UAT Testing', description: 'System testing', level: 'Advanced' },
];

export const CERTIFICATIONS: Certification[] = [
  {
    name: 'Data Analytics Consulting Virtual Internship',
    issuer: 'JPMorgan Chase & Co',
    year: '2023',
    url: 'https://www.theforage.com/',
    icon: 'Building',
  },
  {
    name: 'Data Analysis and Modelling Using MS-Excel',
    issuer: 'Vellore Institute of Technology',
    year: '2023',
    url: 'https://vit.ac.in/',
    icon: 'GraduationCap',
  },
  {
    name: 'AU Data Analytics',
    issuer: 'KPMG',
    year: '2023',
    url: 'https://kpmg.com/',
    icon: 'TrendingUp',
  },
  {
    name: 'Financial Modelling',
    issuer: 'Skill Nation',
    year: '2023',
    url: 'https://skillnation.in/',
    icon: 'Coins',
  },
  {
    name: 'The Fundamentals of Digital Marketing',
    issuer: 'Google',
    year: '2021',
    url: 'https://learndigital.withgoogle.com/digitalgarage',
    icon: 'Globe',
  },
];

// Process — how I work, grounded in the resume
export const APPROACH: { step: string; title: string; description: string }[] = [
  {
    step: '01',
    title: 'Understand the business',
    description:
      'I start inside the workflow — sitting with the teams who live the process daily. Context first: the product, the regulation, the data and where decisions actually get stuck.',
  },
  {
    step: '02',
    title: 'Find the friction',
    description:
      'Manual reports, repeated data entry, blind spots in portfolio risk — I map where hours leak and where leadership is flying without instruments.',
  },
  {
    step: '03',
    title: 'Build and automate',
    description:
      'Dashboards, calculators, MIS pipelines — small sharp tools shipped fast with web tech, Excel and GenAI-assisted prototyping. Not slide decks; working software.',
  },
  {
    step: '04',
    title: 'Test, measure, repeat',
    description:
      'SIT and UAT discipline: defects logged, tracked and closed before go-live. Then iterate — every cycle the tools get sharper and the numbers get better.',
  },
];

// One person, many hats
export const ROLES = [
  'PMO Lead',
  'Business Analyst',
  'Dashboard Builder',
  'Financial Modeler',
  'UAT Tester',
  'MIS Automator',
  'Risk Analyst',
  'GenAI Power User',
];

export const WHY_ME: { title: string; description: string }[] = [
  {
    title: 'Builder inside the business',
    description:
      'I do not hand requirements over a wall — I write the HTML, the formulas and the pipelines myself, then drive adoption in the branches.',
  },
  {
    title: 'Zero-critical go-lives',
    description:
      'SIT and UAT across 3+ core banking modules: 150+ defects logged and tracked to resolution, zero critical bugs at launch.',
  },
  {
    title: 'Hours back, every week',
    description:
      'MIS reports that took ~2 hours now run in under 20 minutes. Manual reporting effort across branches cut by roughly a third.',
  },
  {
    title: 'Finance-grade rigor',
    description:
      'MBA in Finance with audit, taxation and reconciliation experience — the numbers behind the dashboards hold up to scrutiny.',
  },
  {
    title: 'GenAI as a force multiplier',
    description:
      'Prompt engineering and AI-assisted prototyping cut my research-to-insight turnaround by ~40% — and it keeps compounding.',
  },
  {
    title: 'Cross-functional by default',
    description:
      'Technology, operations, compliance — transformation lives between departments, and that is exactly where I work.',
  },
];

export const STATS: { value: string; label: string }[] = [
  { value: '~30%', label: 'Manual reporting effort eliminated' },
  { value: '6x', label: 'Faster MIS report generation' },
  { value: '150+', label: 'Defects tracked to resolution' },
  { value: '0', label: 'Critical bugs at go-live' },
];
